import React, {Component} from 'react';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import fontColorIcon from "./fontColor.png";
import SketchColor from "../../../components/sketchColor/sketchColor";
import {Icon} from "antd";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class FontColorTool extends Component {
    state={
          color:'#000000'
    };

    render() {
        let  {color} = this.state;
        return (
            <span style={{display:'inline-block',cursor:"pointer"}} >
                <span className={"editor-fore-color-tool-btn"} style={{display:'flex',alignItems: 'center'}}>
                    <span
                        onClick={() => {
                            this.props.editor.execCommand('forecolor', `${color}`);
                        }}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <img width={18} src={fontColorIcon}/>
                        <span style={{background: this.state.color, width: 15,height:3}}></span>
                    </span>
                    {/*颜色*/}
                    <SketchColor
                        setTooloColor={(hex)=>{
                            this.state.color = hex;
                            console.log(hex,'hex');
                            this.setState({},()=>{this.props.editor.execCommand('forecolor', `${hex}`);});
                        }}
                        showColorEle={false}
                        toolColor={this.state.color}
                        icon={<Icon type="caret-down"/>}
                        colorEleStyle={{
                            width:toolWidth,
                        }}
                        modalEleStyle={{ top: 120 ,right:565}}
                    />
                </span>
                <style>{`
                    .editor-fore-color-tool-btn{
                        border: 1px solid #f2f6fc;
                        height: 23px
                    }
                    .editor-fore-color-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-fore-color-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>

        );
    }
}

export default FontColorTool;